import React from 'react'

function DonateButton() {
  return (
    <form action="https://www.paypal.com/donate" method="post" target="_top">
    <input type="hidden" name="hosted_button_id" value="773AQLS6MDWMQ" />
    <input type="image" src="https://pics.paypal.com/00/s/ZmZmMGU3NGUtNGU0Ny00NTdkLTk5ZjQtYzZlZjkzMzU1ZTU1/file.PNG" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
    <img alt="" border="0" src="https://www.paypal.com/en_KE/i/scr/pixel.gif" width="1" height="1" />
    </form>
  )
}

export default DonateButton